import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/pricing.css";
import { Link } from "react-router-dom";

const Pricing = () => {

	const [ currency, setCurrency ] = useState("usd");

	return (
		<section id="pricing">
			<h1>Pricing</h1>
			<select onChange={(e) => setCurrency(e.target.value)}>
				<option selected value="usd">United States Dollars (USD)</option>
				<option value="cad">Canadian Dollars (CAD)</option>
				<option value="eur">Euros (EUR)</option>
				<option value="gbp">Pounds Sterling (GBP)</option>
				<option value="aud">Australian Dollars (AUD)</option>
				<option value="kwd">Kuwaiti Dinar (KWD)</option>
				<option value="sgd">Singapore Dollars (SGD)</option>
				<option value="hkd">Hong Kong Dollars (HKD)</option>
				<option value="cny">Chinese Yuan (CNY)</option>
				<option value="myr">Malaysian Ringgit (MYR)</option>
				<option value="idr">Indonesian Rupiah (IDR)</option>
				<option value="krw">South Korean Won (KRW)</option>	
				<option value="dkk">Danish Krone (DKK)</option>	
				<option value="aed">United Arab Emirates Dirham (AED)</option>	
			</select>
			<div id="plans">
				<div className="plan">
					<div className="header">
						<h1>Standard</h1>
						<h2>4 weeks</h2>
						{ currency === "usd" && <h3>$49.99</h3> }
						{ currency === "cad" && <h3>CA$63.24</h3> }
						{ currency === "eur" && <h3>€43.11</h3> }
						{ currency === "gbp" && <h3>£36.91</h3> }
						{ currency === "aud" && <h3>AU$68.86</h3> }
						{ currency === "kwd" && <h3>15.06 KD</h3> }
						{ currency === "sgd" && <h3>S$67.88</h3> }
						{ currency === "hkd" && <h3>HK$389.17</h3> }
						{ currency === "cny" && <h3>¥322.26</h3> }
						{ currency === "myr" && <h3>209.11 RM</h3> }
						{ currency === "idr" && <h3>713207.33 RP</h3> }
						{ currency === "krw" && <h3>₩59774.54</h3> }
						{ currency === "dkk" && <h3>328.46 Kr.</h3> }
						{ currency === "aed" && <h3>183.61 د.إ</h3> }
					</div>
					<ul>
						<li>Lifestyle Changes</li>
						<li>Progress Tracking</li>
						<li>Workout Plan</li>
					</ul>
				</div>
				<div className="plan">
					<div className="header">
						<h1>Premium</h1>
						<h2>8 weeks</h2>
						{ currency === "usd" && <h3>$99.99</h3> }
						{ currency === "cad" && <h3>CA$126.50</h3> }
						{ currency === "eur" && <h3>€86.22</h3> }
						{ currency === "gbp" && <h3>£73.82</h3> }
						{ currency === "aud" && <h3>AU$137.73</h3> }
						{ currency === "kwd" && <h3>30.13 KD</h3> }
						{ currency === "sgd" && <h3>S$135.77</h3> }
						{ currency === "hkd" && <h3>HK$778.43</h3> }
						{ currency === "cny" && <h3>¥644.59</h3> }
						{ currency === "myr" && <h3>418.25 RM</h3> }
						{ currency === "idr" && <h3>1426557.33 RP</h3> }
						{ currency === "krw" && <h3>₩119561.04</h3> }
						{ currency === "dkk" && <h3>656.99 Kr.</h3> }
						{ currency === "aed" && <h3>367.26 د.إ</h3> }
					</div>
					<ul>
						<li>All benefits from standard package</li>
						<li>Includes Diet</li>
						<li>Weekly Coaching</li>
						<li>24/7 Availablity</li>
						<li>Step-by-Step Document</li>
					</ul>
				</div>
				<div className="plan">
					<div className="header">
						<h1>1-on-1 Mentorship</h1>
						<h2>8 weeks</h2>
						{ currency === "usd" && <h3>$199.99</h3> }
						{ currency === "cad" && <h3>CA$253.01</h3> }
						{ currency === "eur" && <h3>€172.46</h3> }
						{ currency === "gbp" && <h3>£147.64</h3> }
						{ currency === "aud" && <h3>AU$275.48</h3> }
						{ currency === "kwd" && <h3>60.27 KD</h3> }
						{ currency === "sgd" && <h3>S$271.55</h3> }
						{ currency === "hkd" && <h3>HK$1556.93</h3> }
						{ currency === "cny" && <h3>¥1289.25</h3> }
						{ currency === "myr" && <h3>836.55 RM</h3> }
						{ currency === "idr" && <h3>2853257.33 RP</h3> }
						{ currency === "krw" && <h3>₩239134.04</h3> }
						{ currency === "dkk" && <h3>1314.05 Kr.</h3> }
						{ currency === "aed" && <h3>734.56 د.إ</h3> }
					</div>
					<ul>
						<li>All benefits from standard and premium packages</li>
						<li>Solo Calls</li>
						<li>Personalized</li>
						<li>Evaluation of Worksheets</li>
					</ul>
				</div>
			</div>
			<Link to="/new-request">Submit a Request</Link>
	</section>
	)
	
};

const PricingPage = () => (
	<>
		<Navbar />
		<Pricing />
		<Footer />
	</>
);

export default PricingPage;